<template>
  <div>
    <div v-if="!isLoading">
      <vs-row class="mb-5">
        <div class="flex justify-end w-full">
          <router-link :to="`/evento-analise/${formData.idEvento}`">
            <vs-button
              type="flat"
              v-if="$can($actionsDefault.Leitura, 'Análise de Eventos')"
            >
              Ir para Análise
            </vs-button>
          </router-link>
        </div>
      </vs-row>

      <!-- Card's -->
      <vs-row class="mt-5">
        <EventosCard :dadosEvento="formData" />
        <AssociadoCard :dadosEvento="formData" />
        <VeiculoCard :dadosEvento="formData" />
      </vs-row>

      <div v-if="1 == 2">
        {{ formData }}
      </div>

      <!-- Status do Evento -->
      <vs-row>
        <vx-card>
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full mb-2">
              <label for="" class="vs-select--label">Status do Evento</label>
              <v-select
                :options="dominios.listSituacoes"
                name="Status Evento"
                id="Status Evento"
                v-model="formData.dadosGerais.idStatus"
                label="label"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Analista Responsável -->
            <div class="vx-col lg:w-1/2 w-full mb-2">
              <label for="" class="vs-select--label"
                >Analista Responsável</label
              >
              <v-select
                :options="dominios.listResponsaveis"
                name="Envolvimento"
                id="Envolvimento"
                v-model="formData.dadosGerais.idUsuario"
                label="label"
                :reduce="(item) => item.id"
              ></v-select>
            </div>
          </div>
        </vx-card>
      </vs-row>

      <!-- Container Principal -->
      <vs-row class="mt-5">
        <vx-card>
          <!-- Tabs -->
          <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top">
            <div class="con-ul-tabs">
              <ul class="ul-tabs vs-tabs--ul ul-tabs-fixed">
                <!-- Tab Dados Gerais -->
                <li
                  class="vs-tabs--li"
                  :class="currentTab == 0 ? 'activeChild' : ''"
                >
                  <button
                    @click="currentTab = 0"
                    type="button"
                    class="vs-tabs--btn"
                  >
                    <span>Dados Gerais</span>
                  </button>
                </li>

                <!-- Tab Reparo do Veículo -->
                <li
                  class="vs-tabs--li"
                  :class="currentTab == 1 ? 'activeChild' : ''"
                >
                  <button
                    @click="currentTab = 1"
                    type="button"
                    class="vs-tabs--btn"
                  >
                    <span>Reparo do Veículo</span>
                  </button>
                </li>

                <!-- Tab Terceiros -->
                <li
                  class="vs-tabs--li"
                  :class="currentTab == 2 ? 'activeChild' : ''"
                >
                  <button
                    @click="currentTab = 2"
                    type="button"
                    class="vs-tabs--btn"
                  >
                    <span>Terceiros</span>
                  </button>
                </li>

                <!-- Tab Patrimonial -->
                <li
                  class="vs-tabs--li"
                  :class="currentTab == 3 ? 'activeChild' : ''"
                >
                  <button
                    @click="currentTab = 3"
                    type="button"
                    class="vs-tabs--btn"
                  >
                    <span>Patrimônios</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <!-- Dados Gerais -->
          <div v-show="currentTab == 0">
            <DadosGeraisView :formData="formData" :dominios="dominios" />
          </div>

          <!-- Reparo do Veículo -->
          <div v-show="currentTab == 1">
            <ReparoVeiculoView :formData="formData" :dominios="dominios" />
          </div>

          <!-- Terceiros -->
          <div v-show="currentTab == 2">
            <TerceirosView
              :idEvento="formData.idEvento"
              :terceiros="formData.terceiros"
            />
          </div>

          <!-- Patrimonial -->
          <div v-show="currentTab == 3">
            <PatrimonioView
              :idEvento="formData.idEvento"
              :patrimonios="formData.patrimonios"
            />
          </div>
        </vx-card>
      </vs-row>

      <ModalLogCilia
        :show.sync="showModalLogCilia"
        :list="formData.listLogsCilia"
      />

      <!-- Botão Salvar -->
      <vs-row class="mt-5">
        <div class="flex justify-between w-full">
          <div class="mb-2 flex gap-3">
            <vs-button
              color="primary"
              type="filled"
              v-if="$can('Histórico de Alterações', 'Eventos')"
              @click="abrirModalHistoricoEventos(formData.idEvento)"
              ><vs-icon icon-pack="feather" icon="icon-list"></vs-icon>
              Histórico Alterações
            </vs-button>

            <vs-button
              v-if="$can('Pode realizar integração Cilia', 'Eventos')"
              @click="sendCilia()"
            >
              Integração Cilia
            </vs-button>

            <vs-button
              type="flat"
              v-if="$can('Pode realizar integração Cilia', 'Eventos')"
              @click="getListLogs()"
            >
              Log's Cilia
            </vs-button>
          </div>

          <div>
            <BotaoSubmit
              v-if="$can($actionsDefault.Escrita, 'Eventos')"
              text="Salvar Alterações"
              :variant="'success'"
              :edit="!loadingButton"
              :aguarde="loadingButton"
              class="ml-4"
              @submit="submit()"
            ></BotaoSubmit>
          </div>
        </div>
      </vs-row>
    </div>
    <div>
      <ModalHistoricoEventos
        :popupActive="modalHistoricoEvento"
        :dadosConsulta="dadosConsultaHistorico"
        @close="closeModais"
      ></ModalHistoricoEventos>
    </div>
  </div>
</template>

<script>
import service from './../../../../services';
import notify from './../../../../utils/notify';
import serviceEventos from './../shared/service';
import utilsLocal from '../utils/';

// Component
import AssociadoCard from './../shared/components/card/AssociadoCard.vue';
import EventosCard from './../shared/components/card/EventoCard.vue';
import VeiculoCard from './../shared/components/card/VeiculoCard.vue';

import DadosGeraisView from './tabs/DadosGerais/DadosGeraisView.vue';
import PatrimonioView from './tabs/Patrimonial/PatrimonioView.vue';
import ReparoVeiculoView from './tabs/ReparoVeiculo/ReparoVeiculoView.vue';
import TerceirosView from './tabs/Terceiros/TerceirosView.vue';

import BotaoSubmit from './../../../../components/BotaoSubmit.vue';
import ModalLogCilia from './components/ModalLogCilia.vue';
import vSelect from 'vue-select';
import ModalHistoricoEventos from '../../../modais/ModalHistoricoEventos.vue';

export default {
  components: {
    AssociadoCard,
    EventosCard,
    VeiculoCard,
    DadosGeraisView,
    PatrimonioView,
    ReparoVeiculoView,
    TerceirosView,
    BotaoSubmit,
    ModalLogCilia,
    vSelect,
    ModalHistoricoEventos,
  },
  data() {
    return {
      isLoading: true,
      currentTab: 0,
      loadingButton: false,
      showModalLogCilia: false,

      //Domínios
      dominios: {
        listEnvolvimentos: [],
        listMotivos: [],
        listSituacoes: [],
        listResponsaveis: [],
        listVistoriadores: [],
        listOficinas: [],
        listTiposVeiculo: [],
        listMarcas: [],
        listModelos: [],
        listCategoriasCarro: [],
        listAnosModelo: [],
        listAnosFabricacao: [],
        listCombustiveis: [],
        listCores: [],
        listEstados: [],
        listLocalizacaoDocumentos: [],
        listGeneros: [
          { id: 1, label: 'Masculino' },
          { id: 2, label: 'Feminino' },
          { id: 3, label: 'Outro' },
        ],
        listTipoCotaParticipacao: [
          { id: 1, label: 'Calcular sobre o valor Fipe atual' },
          {
            id: 2,
            label: 'Calcular sobre o valor Fipe do cadastro do veículo',
          },
          { id: 3, label: 'Outro (editar manual)' },
        ],
      },

      //Formulário
      formData: {
        idEvento: null,
        protocolo: null,
        dadosCliente: {},
        dadosVeiculo: {},
        dadosGerais: {},
        enderecoEvento: {},
        carroReserva: {},
        condutor: {},
        dadosReparo: {},
        reparoVeiculo: {},
        processosDatas: {},
        custoEvento: {},
        terceiros: [],
        patrimonios: [],
        arquivosDadosGerais: [],
        arquivosReparoVeiculo: [],
        listLogsCilia: [],
      },
      dadosConsultaHistorico: {},
      modalHistoricoEvento: false,
    };
  },
  methods: {
    async getListDominios() {
      try {
        this.$vs.loading();

        const promises = [
          serviceEventos.getListDominio(
            'domEventosEnvolvimentos',
            'envolvimento',
            'idEnvolvimento',
          ),
          utilsLocal.bucarMotivos(),
          utilsLocal.bucarSituacoes(),
          serviceEventos.getListUsuarios(),
          serviceEventos.getListVistoriadores(),
          serviceEventos.getListOficinas(),
          serviceEventos.getListDominio(
            'domTipoFipe',
            'nomeTipo',
            'idTipoFipe',
          ),
          serviceEventos.getListCoresAndCombustiveis(),
          serviceEventos.getListDominio('domUf', 'nomeUf', 'codUf'),
          serviceEventos.getListLocalizacaoDocumentacao(),
        ];

        const [
          listEnvolvimentos,
          listMotivos,
          listSituacoes,
          listResponsaveis,
          listVistoriadores,
          listOficinas,
          listTiposVeiculo,
          listCoresAndCombustivel,
          listEstados,
          listLocalizacaoDocumentos,
        ] = await Promise.all(promises);

        listMotivos.forEach((element) => {
          this.dominios.listMotivos.push({
            id: element.idMotivo,
            label: element.nomeMotivo,
          });
        });

        listSituacoes.forEach((element) => {
          this.dominios.listSituacoes.push({
            id: element.idStatus,
            label: element.nomeStatus,
          });
        });

        this.dominios.listEnvolvimentos = listEnvolvimentos;
        this.dominios.listResponsaveis = listResponsaveis;
        this.dominios.listVistoriadores = listVistoriadores;
        this.dominios.listOficinas = listOficinas;
        this.dominios.listTiposVeiculo = listTiposVeiculo;
        this.dominios.listCores = listCoresAndCombustivel.listCores;
        this.dominios.listCombustiveis =
          listCoresAndCombustivel.listCombustiveis;
        this.dominios.listEstados = listEstados;
        this.dominios.listLocalizacaoDocumentos = listLocalizacaoDocumentos;
      } catch (error) {
        console.error(error);
        notify.notifyFail(this.$vs, 'Falha ao carregar os dados do evento');
      } finally {
        this.$vs.loading.close();
      }
    },
    async getEvento() {
      const { idEvento } = this.$route.params;

      if (!idEvento) {
        return;
      }

      try {
        this.$vs.loading();

        const result = await service.getAll('eventos2', null, idEvento);
        const evento = result.data;

        if (!evento) {
          notify.notifyFail(
            this.$vs,
            'Você não tem acesso a visualização deste Evento',
          );
          this.$vs.loading.close();
          return;
        }

        this.isLoading = false;

        this.$nextTick(() => {
          this.formData = evento;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async submit() {
      try {
        this.$vs.loading();

        const idUsuarioSend = serviceEventos.getIdUsuario();
        const data = { ...this.formData, idUsuarioSend };
        const dataEvento = await service.post(
          'eventos2',
          'update-evento',
          data,
        );

        this.formData = dataEvento.data;
        notify.notifySuccess(this.$vs, 'Evento salvo com sucesso!');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async sendCilia() {
      try {
        this.$vs.loading();

        const data = {
          idEvento: this.formData.idEvento,
        };

        await service.post('integracao-cilia', 'criar-orcamento', data);

        notify.notifySuccess(this.$vs, 'Integração com o Cillia realizada');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getListLogs() {
      try {
        this.$vs.loading();

        const result = await service.getAll(
          'integracao-cilia',
          {},
          `/log/${this.formData.idEvento}`,
        );

        this.formData.listLogsCilia = result.data;
        this.showModalLogCilia = true;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    abrirModalHistoricoEventos(idEvento) {
      this.dadosConsultaHistorico = idEvento;
      this.modalHistoricoEvento = true;
    },
    closeModais() {
      this.modalHistoricoEvento = false;
    },
  },
  async mounted() {
    await this.getListDominios();
    await this.getEvento();
  },
};
</script>

<style lang="scss">
li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}

.assinatura {
  max-width: 100%;
  max-height: 200px;
}
.vdp-datepicker input {
  width: 100%;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
